// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyA-2tok1vJn3gn8dS_bYUwVwt07Cc5WXno",
  authDomain: "shop-aa8dd.firebaseapp.com",
  projectId: "shop-aa8dd",
  storageBucket: "shop-aa8dd.appspot.com",
  messagingSenderId: "201014988618",
  appId: "1:201014988618:web:6e6d5f9f70f7e9f37bfbb3"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export default app;